import { useRef, useState } from "react";
import Apiservice from "../Apiservice";
import { useNavigate, useParams } from "react-router-dom";

const AddQuestion = () => {
    const { examId } = useParams();
    const navigate = useNavigate();

    console.log("add question body");

    const questionRef = useRef("");
    const option1Ref = useRef("");
    const option2Ref = useRef("");
    const option3Ref = useRef("");
    const option4Ref = useRef("");
    const explanationRef = useRef("");
    const [selectedOption, setSelectedOption] = useState(null);
    const [errors, setErrors] = useState({});

    let data = {
        exam_id: examId,
        question: questionRef.current.value,
        options: [
            { option1: option1Ref.current.value, isCorrect: selectedOption === "1" },
            { option2: option2Ref.current.value, isCorrect: selectedOption === "2" },
            { option3: option3Ref.current.value, isCorrect: selectedOption === "3" },
            { option4: option4Ref.current.value, isCorrect: selectedOption === "4" },
            { selectedOption: selectedOption }
        ],
        explanation: explanationRef.current.value
    }

    const validateForm = () => {
        const newErrors = {};
        if (!questionRef.current.value.trim()) {
            newErrors.question = "Question is required";
        }

        if (!option1Ref.current.value.trim()) {
            newErrors.option1 = "Option1 is required";
        }

        if (!option2Ref.current.value.trim()) {
            newErrors.option2 = "Option2 is required";
        }

        if (!option3Ref.current.value.trim()) {
            newErrors.option3 = "Option3 is required";
        }
        if (!option4Ref.current.value.trim()) {
            newErrors.option4 = "Option4 is required";
        }
        if (!selectedOption) {
            newErrors.selectedOption = "Please select a correct answer";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const fetchData = async () => {
        if (!validateForm()) {
            return;
        }
        const token = localStorage.getItem("access_token");
        console.log("Add question function")
        // Define custom headers
        const headers = { access_token: token };
        let result = await Apiservice.AddQuestion(data, headers);
        console.log("questionadd result", result);
        if (result.success == true) {
            navigate(`/allquestions/${(examId)}`, {
                state: {
                    newQuestionId: result.data?.insertId
                }
            });
        } else {
            alert(result.message);
        }
    };

    // Function to handle radio button change
    const handleOptionChange = (event) => {
        setSelectedOption(event.target.value);
    };

    return (
        <>
            <div className="container-fluid p-md-2 p-0" style={{ backgroundColor: 'white', userSelect: 'none' }}>
                <div className="row mb-2">
                    <div className="col-12">
                        <div className="row text-center mb-2">
                            <div className="col">Add New Question</div>
                        </div>
                        <div className="questionadd p-md-2 p-0">
                            <div className="row mb-2">
                                <div className="col-3">
                                    <label htmlFor="" className="form-label">Question</label>
                                </div>
                                <div className="col-9">
                                    <textarea
                                        name=""
                                        id=""
                                        rows="3"
                                        className={`form-control form-control-sm ${errors.question ? "is-invalid" : ""}`}
                                        //onChange={(e) => setQuestion(e.target.value)}
                                        ref={questionRef}
                                    ></textarea>
                                    {errors.question && <div className="invalid-feedback">{errors.question}</div>}
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-3">
                                    <label htmlFor="" className="form-label">Options</label>
                                </div>
                                <div className="col-12 col-md-9">
                                    <div className="row mb-1">
                                        <div className="col-md-1 col-2 text-end">
                                            <input
                                                type="radio"
                                                className="btn-check"
                                                name="options"
                                                id="option1"
                                                value="1"
                                                checked={selectedOption === "1"}
                                                onChange={handleOptionChange}
                                            />
                                            <label className="btn btn-outline-danger" htmlFor="option1">a</label>
                                        </div>
                                        <div className="md-col col">
                                            <input
                                                type="text"
                                                name="option1"
                                                id="option1-text"
                                                className={`form-control form-control-sm ${errors.option1 ? "is-invalid" : ""}`}
                                                placeholder="Option - a?"
                                                // onChange={(e) => setOption1(e.target.value)}
                                                ref={option1Ref}
                                            />
                                            {errors.option1 && <div className="invalid-feedback">{errors.option1}</div>}
                                        </div>
                                    </div>

                                    <div className="row mb-1">
                                        <div className="col-md-1 col-2 text-end">
                                            <input
                                                type="radio"
                                                className="btn-check btn-check-sm"
                                                name="options"
                                                id="option2"
                                                value="2"
                                                checked={selectedOption === "2"}
                                                onChange={handleOptionChange}

                                            />
                                            <label className="btn btn-outline-danger" htmlFor="option2">b</label>
                                        </div>
                                        <div className="md-col col">
                                            <input
                                                type="text"
                                                name="option2"
                                                id="option2-text"
                                                className={`form-control form-control-sm ${errors.option2 ? "is-invalid" : ""}`}
                                                placeholder="Option - b?"
                                                //onChange={(e) => setOption2(e.target.value)}
                                                ref={option2Ref}
                                            />
                                            {errors.option2 && <div className="invalid-feedback">{errors.option2}</div>}
                                        </div>
                                    </div>

                                    <div className="row mb-1">
                                        <div className="col-md-1 col-2 text-end">
                                            <input
                                                type="radio"
                                                className="btn-check btn-check-sm"
                                                name="options"
                                                id="option3"
                                                value="3"
                                                checked={selectedOption === "3"}
                                                onChange={handleOptionChange}
                                            />
                                            <label className="btn btn-outline-danger" htmlFor="option3">c</label>
                                        </div>
                                        <div className="md-col col">
                                            <input
                                                type="text"
                                                name="option3"
                                                id="option3-text"
                                                className={`form-control form-control-sm ${errors.option3 ? "is-invalid" : ""}`}
                                                placeholder="Option - c?"
                                                //  onChange={(e) => setOption3(e.target.value)}
                                                ref={option3Ref}
                                            />
                                            {errors.option3 && <div className="invalid-feedback">{errors.option3}</div>}
                                        </div>
                                    </div>

                                    <div className="row mb-1">
                                        <div className="col-md-1 col-2 text-end">
                                            <input
                                                type="radio"
                                                className="btn-check btn-check-sm"
                                                name="options"
                                                id="option4"
                                                value="4"
                                                checked={selectedOption === "4"}
                                                onChange={handleOptionChange}
                                            />
                                            <label className="btn btn-outline-danger" htmlFor="option4">d</label>
                                        </div>
                                        <div className="md-col col">
                                            <input
                                                type="text"
                                                name="option4"
                                                id="option4-text"
                                                className={`form-control form-control-sm ${errors.option4 ? "is-invalid" : ""}`}
                                                placeholder="Option - d?"
                                                // onChange={(e) => setOption4(e.target.value)}
                                                ref={option4Ref}
                                            />
                                            {errors.option4 && <div className="invalid-feedback">{errors.option4}</div>}
                                        </div>
                                    </div>
                                    {errors.selectedOption && <div className="text-danger">{errors.selectedOption}</div>}
                                </div>
                            </div>

                            {/* <div className="row mb-2">
                                <div className="col-3">Explanation</div>
                                <div className="col-9">
                                    <input
                                        type="text"
                                        name="explanation"
                                        id="explanation-text"
                                        className="form-control form-control-sm"
                                        placeholder="Explanation"
                                        onChange={(e) => setExplanation(e.target.value)}
                                        ref={}
                                    />
                                </div>
                            </div> */}

                            <div className="row text-center">
                                <div className="col">
                                    <button className="btn btn-sm btn-primary" onClick={fetchData}>Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AddQuestion;
